import React from "react";
import LandingHero from "./landingpage/LandingHero";
import LandingSocials from "./landingpage/LandingSocials";
import LandingBonuses from "./landingpage/LandingBonuses";
import LandingLeaderboards from "./landingpage/LandingLeaderboards";
import LandingYouTube from "./landingpage/LandingYouTube";


const Index = () => {

    return (
        <div className={"fadeIn landingPage"}>

            <LandingHero />
            <LandingBonuses />
            <LandingLeaderboards />
            {/* <LandingYouTube /> */}
            <LandingSocials />

        </div>
    );
}

export default Index;